import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MenuItem, MessageService, SelectItem } from 'primeng/api';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ImportOrderGateway } from 'src/app/application/gateway/ImportOrderGateway';
import { PalletGateway } from 'src/app/application/gateway/PalletGateway';
import { SpeciesGateway } from 'src/app/application/gateway/SpeciesGateway';
import { VarietyGateway } from 'src/app/application/gateway/VarietyGateway';
import { ImportOrderDetailInformation } from 'src/app/domain/models/ImportOrder';
import { FilterLoadRequest, FilterLoadsResponse, LoadOrderListItem, LoadsRequestPaged, OrderListItem } from 'src/app/domain/models/LoadOrder';
import { NewPallet } from 'src/app/domain/models/Pallet';
import { Profile } from 'src/app/domain/models/Profile';
import { Species } from 'src/app/domain/models/Species';
import { BasicUser } from 'src/app/domain/models/User';
import { Variety } from 'src/app/domain/models/Variety';
import { Routes } from 'src/app/infrastructure/routes';
import { FilterLoadsUtils, MyLoadsFilter, MyLoadsFilterProgram } from 'src/app/ui/util/custom-filters-my-loads';
import { IImportOrderStatus, OrderUtils } from 'src/app/ui/util/order-utils';
import { BasicSelect } from 'src/app/ui/util/select-utils';
import { transportTypes } from 'src/app/ui/util/transportType.Utils';


@Component({
  selector: 'app-user-load-orders-program',
  templateUrl: './user-load-orders-program.component.html',
  styleUrls: ['./user-load-orders-program.component.css'],
  providers: [ConfirmationService]

})
export class UserLoadOrdersProgramComponent implements OnInit {
  @ViewChild('dataView') dataView: any;

  activeItem: MenuItem = {}
  orders: OrderListItem[] = []
  filteredOrders: LoadOrderListItem[] = []
  formatedOrders: OrderListItem[] = []
  profile: BasicUser | undefined
  orderDetailInformation: ImportOrderDetailInformation | undefined
  pallets: NewPallet  [] = []

  loading: boolean = false
  loadingVarieties: boolean = false
  statuses: any[] = [];
  showPallets: boolean = false
  isEdit: boolean = true
  years: number[] = []
  year: number = new Date().getFullYear()

  searchTerm: string = '';

  filterProfile: Profile[] = []
  programs: {name: string}[] = []
  transportTypes: {type: number, name: string}[] = []
  orderStatus: IImportOrderStatus[] = []
  importOrders: {name: string}[] = [];
  transportType: number = 0
  programFilter: string = ''

  lang: string = 'en';
  profileSelected: Profile | undefined;
  programSelected: number | undefined;
  importOrderSelected: string | undefined;
  statusSelected: number | undefined;
  showAdvancedFilters: boolean = false
  advancedFilterForm: FormGroup = this._formBuilder.group({
    speciesId: '',
    varietyId: '',
    transportType: 0,
    naveId: '',
    departurePortId: '',
    destinationPortId: '',
    clientId: '',
    year: null,
    programId: '',
    importOrder: '',
    status: '',
  })

  varieties: Variety[] = []
  species: Species[] = []
  filterSpecies: Species[] = []
  filterVarieties: Variety[] = []
  selectedSpecies: Species | undefined
  transportSelect: BasicSelect[] = transportTypes
  naveSelect: SelectItem[] = []
  departurePortSelect: SelectItem[] = []
  destinationPortSelect: SelectItem[] = []
  storedFilters: MyLoadsFilter = {} as MyLoadsFilter
  isProfileChanged: boolean = false

  @Input()
  activeItemIndex = 0

  request: LoadsRequestPaged  = {
    year: new Date().getFullYear(),
    isClosedSale: true,

  }

  totalCount = 0;
  pageSize = 10;

  constructor(private readonly _router: Router,
    private readonly _authService: AuthGateway,
    private readonly _messageService: MessageService,
    private readonly _importOrderService: ImportOrderGateway,
    private readonly _palletService: PalletGateway,
    private readonly _speciesService: SpeciesGateway,
    private readonly _varietyService: VarietyGateway,
    private readonly _formBuilder: FormBuilder,
    public translate: TranslateService) {
      // TODO aleyton: eliminar temporalmente
      // const storedFilters = FilterLoadsUtils.getFilterProgramConfig()
      // if (storedFilters) this.storedFilters = storedFilters

      OrderUtils.getOrderDocumentStatus().forEach(element => {
        this.orderStatus.push(element)
      })
  }

  ngOnInit(): void {
    // TODO aleyton: eliminar temporalmente
    // this.year = this.storedFilters?.year ?? new Date().getFullYear()
    this.advancedFilterForm.get('year')?.setValue(this.year)
    this.profile = this._authService.getUser()
    if(this.profile){
      this.lang = this.profile.lang;
    }

    // TODO aleyton: eliminar temporalmente
    // if (this.storedFilters?.clientId) {
    //   this.searchByCompany(this.storedFilters.clientId)
    // }
    // else {
    //   this.getLoads()
    // }

    this.getLoadsFilter()
    this.getYears()
    //this.loadSpecies()

    this.statuses = [
      { label: 'Created', value: 0 },
      { label: 'Pending Verify Pallets', value: 1 },
      { label: 'QC Pallets Verified', value: 2 },
      { label: 'Order Confirmed', value: 3 },
      { label: 'Payment Confirmed', value: 4 }
    ];

    this.getFilterCompanies()
    // TODO aleyton: eliminar temporalmente
    // this.setStoredData()
  }

  getLoadWithFilters()
  {
    this.getLoadsFilter()
    this.getLoads()
  }

  setStoredData() {
    this.programSelected = this.storedFilters?.programId
    this.importOrderSelected = this.storedFilters?.importOrder
    this.statusSelected = this.storedFilters?.status
    this.advancedFilterForm.patchValue({
      speciesId: this.storedFilters?.speciesId ?? '',
      transportType: this.storedFilters?.transportType ?? 0,
      year: this.storedFilters?.year ?? new Date().getFullYear(),
      programId: this.storedFilters?.programId,
      importOrder: this.storedFilters?.importOrder,
      status: this.storedFilters?.status
    })
  }

  getYears() {
    let current = new Date()
    let currentYear = current.getFullYear()

    for(let i = 2023; i <= currentYear; i++) {
      this.years.push(i)
    }
  }

  getLoadsPage(event: any)
  {
    const pageNumber = Math.floor(event.first / event.rows) + 1;
    const pageSize = event.rows;

    this.getLoads(pageNumber, pageSize);
  }

  getLoads(pageNumber: number = 1, pageSize: number = 10)
  {
    this.setUpFilter(pageNumber, pageSize);
      this.loading = true;
      this._importOrderService.getAllMyLoadsPaged(this.request).subscribe({
        next: (v) => {
          this.orders = this.formatOrders(v.items)
          this.totalCount = v.totalCount;
          this.loading = false
        },
        error: (e) => {
          this.loading = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.ImportOrder.ManyRetrieveError') });
        }
      })
    // }
  }

  setUpFilter(pageNumber: number = 1, pageSize: number = 10)
  {
    this.request = {
      pageNumber,
      pageSize,
      isClosedSale: true,
      year: this.year
    }

    if( this.advancedFilterForm.controls['departurePortId'].value)
      this.request.departurePortId = this.advancedFilterForm.controls['departurePortId'].value;

    if(this.advancedFilterForm.controls['destinationPortId'].value)
      this.request.destinationPortId = this.advancedFilterForm.controls['destinationPortId'].value;

    if(this.advancedFilterForm.controls['varietyId'].value)
      this.request.varietyId = this.advancedFilterForm.controls['varietyId'].value;

    if(this.advancedFilterForm.controls['speciesId'].value)
      this.request.speciesId = this.advancedFilterForm.controls['speciesId'].value;

    if(this.advancedFilterForm.controls['naveId'].value)
      this.request.ship = this.advancedFilterForm.controls['naveId'].value;

    if(this.importOrderSelected)
      this.request.orderId =  parseInt(this.importOrderSelected);

    this.request.year = this.year;
    if(this.programSelected)
      this.request.programId = this.programSelected;

    if(this.profileSelected)
    {
      if(this.profile?.type == 1)
      {
        this.request.importerId = this.profileSelected.id;
      }else if(this.profile?.type == 1){
        this.request.exporterId = this.profileSelected.id;
      }
    }

    if(this.statusSelected)
    {
      this.request.status = this.statusSelected
    }
  }

  loadSpecies() {
    this._speciesService.getAllByProductType(1).subscribe({
      next: (v) => {
        this.species = v
        if (this.storedFilters?.speciesId) this.loadVarieties(this.storedFilters?.speciesId)
      },
      error: (e) => {
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Species.ManyRetrieveError') })
      }
    })
  }

  loadVarieties(speciesId?: string) {
    const id = speciesId ?? this.advancedFilterForm.controls['speciesId'].value
    this.selectedSpecies = this.species.find(x => x.id === id)
    this.varieties = []
    this.loadingVarieties = true
    if (this.selectedSpecies) {
      this._varietyService.getAllBySpecies(id).subscribe({
        next: (v) => {
          this.varieties = v
          this.loadingVarieties = false

          if (this.storedFilters?.varietyId) {
            this.advancedFilterForm.patchValue({
              varietyId: this.storedFilters?.varietyId ?? ''
            })
          }
        },
        error: (e) => {
          this.loadingVarieties = false
          this._messageService.add({ severity: 'error',
            summary: this.translate.instant('MessageService.Summary.FailedAction'),
            detail: this.translate.instant('MessageService.Variety.ManyRetrieveError') })
        }
      })
    }
  }

  setFilters(orders: LoadOrderListItem[]) {
    orders.forEach((el) => {
      if (!this.naveSelect.find((nave) => nave.value === el.ship) && el.ship) {
        this.naveSelect.push({value: el.ship})
      }
      if (!this.departurePortSelect.find((port) => port.value === el.originPort?.id) && el.originPort?.id) {
        this.departurePortSelect.push({label: el.originPort?.name, value: el.originPort?.id})
      }
      if (!this.destinationPortSelect.find((port) => port.value === el.destinationPort?.id) && el.destinationPort?.id) {
        this.destinationPortSelect.push({label: el.destinationPort?.name, value: el.destinationPort?.id})
      }
    })

    // TODO aleyton: eliminar temporalmente
    // if (this.storedFilters) {
    //   this.advancedFilterForm.get('naveId')?.setValue(this.storedFilters?.naveId ?? '')
    //   this.advancedFilterForm.get('departurePortId')?.setValue(this.storedFilters?.departurePortId ?? '')
    //   this.advancedFilterForm.get('destinationPortId')?.setValue(this.storedFilters?.destinationPortId ?? '')
    // }
  }

  getFilterCompanies(){
    if(this.profile){
      if(this.profile?.type === 2){
        this._importOrderService.getExportersLoads(true).subscribe({
         next: (v) => {
           this.filterProfile = v
           if (this.storedFilters?.clientId) {
            this.profileSelected = v.find((el) => el.id === this.storedFilters.clientId)
            this.advancedFilterForm.patchValue({
              clientId: this.storedFilters?.clientId
            })
           }
         },
         error: (e) => {
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: this.translate.instant("MessageService.MyLoads.ManyCompanyRetrieveError") });
         }
        })
     }else{
      this._importOrderService.getImportersLoads(true).subscribe({
        next: (v) => {
          this.filterProfile = v
          if (this.storedFilters?.clientId) {
           this.profileSelected = v.find((el) => el.id === this.storedFilters.clientId)
           this.advancedFilterForm.patchValue({
             clientId: this.storedFilters?.clientId
           })
          }
        },
        error: (e) => {
         this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: this.translate.instant("MessageService.MyLoads.ManyCompanyRetrieveError") });
        }
       })
     }
    }
  }

  filterProgram(event?: any){
    if(event){
      let value = event.value
      if(value){
          this.programFilter = value
          this.filteredOrders = this.orders.filter(order =>
            order.programId == value && order.transportType == this.advancedFilterForm.get('transportType')?.value
          )
        // }
      }
    }
  }

  makeFilter() {
    this.clearProgramFilter()
    this.getLoadWithFilters();
    if (this.dataView) {
      this.dataView.first = 0;
    }
  }

  formatOrders(orders: LoadOrderListItem[]) {
    this.formatedOrders = JSON.parse(JSON.stringify(orders))
    this.formatedOrders.forEach((order) => {
      order.details.forEach((detail) => {
        order.orderDetailId = detail.id
        order.varietyUrlIcon = detail.varietyUrlIcon
        order.speciesId = detail.speciesId
        order.speciesNameEs = detail.speciesNameEs
        order.speciesNameEn = detail.speciesNameEn
        order.loadingAction = detail.loadingAction
        order.boxesQuantity = detail.boxesQuantity
        order.status = detail.status
        order.varietyId = detail.varietyId
        order.varietyName = detail.varietyName
        order.exporterCompanyName = detail.exporterCompanyName
      })
    })
    return this.formatedOrders
  }

  clearCompanyFilter(){
    this.orders = []
    this.filteredOrders = []
    this.formatedOrders = []
    this.getLoads();
  }

  clearProgramFilter(){
    this.programFilter = ''
  }

  viewPallets(detail: OrderListItem) {
    if (detail.orderDetailId) {
      detail.loadingAction = true
      this._palletService.getByImportOrderDetailId(detail.orderDetailId).subscribe({
        next: (v) => {
          this.orderDetailInformation = v
          this.pallets = this.orderDetailInformation.pallets.filter(x => x.status === 2)
          this.showPallets = true
          detail.loadingAction = false
        },
        error: (e) => {
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: this.translate.instant("MessageService.MyLoads.LoadsRetrieveError") });
        },
        complete: () =>  {
          detail.loadingAction = false
        }
      })
    }
  }

  generateShipmentData(data: FilterLoadsResponse) {
        data.programs.forEach(item => this.programs.push({name: item.toString()}));


      data.orders.forEach
      (item => this.importOrders.push({name: item.toString()}));

      this.species = data.species;

      data.ships.forEach(item => this.naveSelect.push({value: item}))

      data.destinationPorts.forEach(item => this.destinationPortSelect.push({label: item.name, value: item.id}))
      data.departurePorts.forEach(item => this.departurePortSelect.push({label: item.name, value: item.id}))
  }

  filterCompany(event: any)
  {
    if(event.value){
      this.searchByCompany()
    }
  }

  getLoadsFilter()
  {

    this.programs = []
    this.importOrders = []
    this.species = []
    this.destinationPortSelect = [];
    this.departurePortSelect = [];
    this.programFilter = ""

    let request: FilterLoadRequest = {
      year: this.year,
      isClosedSale: true
    }

    if(this.programSelected)
    {
      request.programId = this.programSelected
    }

    if(this.profileSelected){
      request.importerId = this.profileSelected.id;
    }

    this._importOrderService.getAllMyLoadsFilter(request).subscribe({
      next: (v) => {
          this.generateShipmentData(v);
      },
      error: (e) => {
          this._messageService.add({ severity: 'error', summary: 'Acción fallida', detail: this.translate.instant("MessageService.MyLoads.LoadsRetrieveError") });
          this.loading = false;
      }
    })

  }

  searchByCompany()
  {
    this.getLoads();

  }

  goToMasterViewPage(): void {
    this.saveFilterProgramRedirect()
    this._router.navigate([Routes.userLoadMasterOrdersProgram]);
  }

  goToContainersViewPage(): void {
    this.saveFilterProgramRedirect()
    this._router.navigate([Routes.userLoadContainersOrdersProgram]);
  }

  goToPalletsViewPage(): void {
    this.saveFilterProgramRedirect()
    this._router.navigate([Routes.userLoadPalletsOrdersProgram]);
  }

  saveFilterProgramRedirect() {
    let filterProgram: MyLoadsFilterProgram = {
      // TODO aleyton: eliminar temporalmente
      // profileName: this.profileSelected?.companyName,
      // programId: this.programSelected,
      // status: this.statusSelected,
      // importOrder: this.importOrderSelected,
      // transportType: this.advancedFilterForm.get('transportType')?.value,
      // speciesId: this.advancedFilterForm.get('speciesId')?.value,
      // varietyId: this.advancedFilterForm.get('varietyId')?.value,
      // naveId: this.advancedFilterForm.get('naveId')?.value,
      year: this.year
    }

    FilterLoadsUtils.saveFilterProgramConfig(filterProgram);
  }

  goToPackingListViewPage(importOrderDetailGuid: string): void {
    const url = this._router.serializeUrl(
      this._router.createUrlTree([`${Routes.packingListView}/${importOrderDetailGuid}`], {queryParams: { isProgram: true }}))
      window.open(url, '_blank');
  }

  goToInstructiveViewPage(importOrderDetailGuid: string): void {
    const url = Routes.instructiveView + "/"+ importOrderDetailGuid + "?isProgram=true"
    window.open(url, '_blank');
  }

  redirectToDocumentation(order: OrderListItem) {
    this._router.navigate(['/' + Routes.userClosedSaleImportOrderDetailPage, order.id, order.directSaleGuid], { fragment: 'user-order-documentation' });
  }

  setMainAdvancedFilters() {
    const profile = this.filterProfile.find((el) => el.id === this.getAdvancedFormValue('clientId'))
    this.profileSelected = profile ?? undefined
    this.year = this.getAdvancedFormValue('year')
    this.programSelected = this.getAdvancedFormValue('programId') ?? undefined
    this.importOrderSelected = this.getAdvancedFormValue('importOrder') ?? undefined
    this.statusSelected = this.getAdvancedFormValue('status')
  }

  getAdvancedFormValue(key: string) {
    return this.advancedFilterForm.get(key)?.value
  }

  onOpenAdvancedFilters() {
    this.advancedFilterForm.patchValue({
      clientId: this.profileSelected?.id,
      year: this.year,
      programId: this.programSelected,
      importOrder: this.importOrderSelected,
      status: this.statusSelected
    })
    this.showAdvancedFilters = true
  }

  onApplyFilters() {
    const isYearChanged = this.year !== this.getAdvancedFormValue('year')
    this.setMainAdvancedFilters()

    if (this.getAdvancedFormValue('clientId')) {
      this.isProfileChanged = true;
      this.getLoadWithFilters()
    }
    else if  (isYearChanged || this.isProfileChanged) {
        this.isProfileChanged = false;
        this.getLoadWithFilters()
    }else{
      this.getLoads();
    }

  }

  onClearFilters() {
    FilterLoadsUtils.removeFilterProgramConfig();
    this.searchTerm = ''
    this.varieties = []
    this.profileSelected = undefined
    this.programSelected = undefined
    this.importOrderSelected = undefined
    this.statusSelected = undefined
    this.advancedFilterForm.reset()
    this.advancedFilterForm.get('transportType')?.setValue(0)
    this.year = new Date().getFullYear()
    this.advancedFilterForm.get('year')?.setValue(this.year)
    this.storedFilters = {} as MyLoadsFilter
    this.makeFilter()
  }
}
